var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "vue", "../Models/Configuration/PhysicalScreen", "../Shared/KendoDataExtracter", "./BasicViewControllerWithCRUDDataSource"], function (require, exports, vue_1, PhysicalScreen_1, KendoDataExtracter_1, BasicViewControllerWithCRUDDataSource_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var AV2;
    (function (AV2) {
        var Controllers;
        (function (Controllers) {
            var TvsScreensBoxesConnectControllerWithCustomCRUDDataSource = (function (_super) {
                __extends(TvsScreensBoxesConnectControllerWithCustomCRUDDataSource, _super);
                function TvsScreensBoxesConnectControllerWithCustomCRUDDataSource(options_) {
                    return _super.call(this, options_) || this;
                }
                TvsScreensBoxesConnectControllerWithCustomCRUDDataSource.prototype.initVue = function () {
                    var base = this;
                    this.vueRoot = new vue_1.default({
                        el: this.options.htmlElementSelector,
                        data: {
                            model: [],
                            showModal: false,
                            ddOptions: [],
                            ddLoading: false,
                            displayDataModel: new PhysicalScreen_1.PhysicalScreen(),
                            modal: {
                                message: ''
                            }
                        },
                        components: {
                            'modal': {
                                template: '#modal-template',
                            }
                        },
                        methods: {
                            customLabel: function (_a) {
                                var Name = _a.Name, SerialNumber = _a.SerialNumber;
                                return Name + " (" + SerialNumber + ")";
                            },
                            Update: function (event) {
                                base.PreventUnnecessaryChanges();
                                base.remoteDataSource.sync();
                            },
                            ShowConfirm: function () {
                                this.showModal = true;
                            },
                            CloseConfirm: function () {
                                this.showModal = false;
                            },
                            DsGetNewInstanceOfType: function (type) {
                                return base.GetNewInstanceOfType(type);
                            },
                            GetDdOptionsAsync: function () {
                                var _this = this;
                                this.ddLoading = true;
                                jQuery.get(base.options.boxesDdOptionsApiUrl).then(function (response) {
                                    _this.ddOptions = response;
                                    for (var i in _this.ddOptions) {
                                        if (_this.ddOptions[i].IsAssigned && _this.ddOptions[i].DisplayId && _this.ddOptions[i].DisplayId != _this.displayDataModel.Id)
                                            _this.ddOptions[i].$isDisabled = true;
                                    }
                                    _this.ddLoading = false;
                                }, function (response) {
                                    window.alert("Es ist leider ein Fehler passiert. Verfügbare Boxen konnten leider abgefragt werden. ");
                                });
                            },
                            GetDisplayDataAsync: function () {
                                var _this = this;
                                jQuery.get(base.options.displayDataApiUrl).then(function (response) {
                                    _this.displayDataModel = response;
                                    _this.GetDdOptionsAsync();
                                }, function (response) {
                                    window.alert("Es ist leider ein Fehler passiert. Displaydaten konnten leider abgefragt werden. ");
                                });
                            },
                            DdRemove: function (item, id) {
                                console.log("remove", item, id);
                                item.IsAssigned = false;
                                var dsItem = base.remoteDataSource.get(item.Id);
                                base.remoteDataSource.remove(dsItem);
                            },
                            DdSelect: function (item, id) {
                                console.log("select", item, id);
                                item.IsAssigned = true;
                                console.log(base.remoteDataSource.add(item));
                                var dsItem = base.remoteDataSource.get(item.Id);
                                dsItem.dirty = true;
                            }
                        },
                        created: function () {
                            this.GetDisplayDataAsync();
                        }
                    });
                };
                TvsScreensBoxesConnectControllerWithCustomCRUDDataSource.prototype.PreventUnnecessaryChanges = function () {
                    var cancelChangesItemsList = {};
                    for (var a = 0; a < (this.remoteDataSource).updated().length; a++)
                        for (var b = 0; b < (this.remoteDataSource).destroyed().length; b++)
                            if ((this.remoteDataSource).updated()[a].Id === (this.remoteDataSource).destroyed()[b].Id)
                                cancelChangesItemsList[(this.remoteDataSource).updated()[a].Id] = (this.remoteDataSource).updated()[a];
                    for (var i in cancelChangesItemsList) {
                        this.remoteDataSource.cancelChanges(cancelChangesItemsList[i]);
                    }
                    var toDestroyArray = (this.remoteDataSource).destroyed();
                    var toReplaceIdArray = [];
                    var toReplaceWithIdList = [];
                    for (var i in toDestroyArray) {
                        if (cancelChangesItemsList.hasOwnProperty(toDestroyArray[i].Id))
                            toDestroyArray[i].skipDeleteFlag = true;
                    }
                    console.log('cancelChangesItemsList:', cancelChangesItemsList);
                };
                TvsScreensBoxesConnectControllerWithCustomCRUDDataSource.prototype.CustomRemoteDatasourceRead = function (options) {
                    var base = this;
                    $.ajax({
                        url: base.options.readApiUrl,
                        type: "get", dataType: "json", contentType: "application/json",
                        success: function (result) {
                            options.success(result);
                        },
                        error: function (result) {
                            options.error(result);
                        }
                    });
                };
                TvsScreensBoxesConnectControllerWithCustomCRUDDataSource.prototype.CustomRemoteDatasourceUpdate = function (options) {
                    var base = this;
                    if (options.data == null)
                        return;
                    $.ajax({
                        url: base.options.updateApiUrl + options.data.Id,
                        type: "get", dataType: "json", contentType: "application/json",
                        success: function (result) {
                            options.success(result);
                        },
                        error: function (result) {
                            options.error(result);
                        }
                    });
                };
                TvsScreensBoxesConnectControllerWithCustomCRUDDataSource.prototype.CustomRemoteDatasourceDestroy = function (options) {
                    var base = this;
                    if (options.data == null)
                        return;
                    if (options.data.skipDeleteFlag) {
                        options.success(true);
                        return;
                    }
                    $.ajax({
                        url: base.options.destroyApiUrl + options.data.Id,
                        type: "get", dataType: "json", contentType: "application/json",
                        success: function (result) {
                            options.success(result);
                        },
                        error: function (result) {
                            options.error(result);
                        }
                    });
                };
                TvsScreensBoxesConnectControllerWithCustomCRUDDataSource.prototype.initRemoteDatasource = function () {
                    var _this = this;
                    var base = this;
                    this.remoteDataSource = new kendo.data.DataSource({
                        batch: false,
                        transport: {
                            read: function (o) {
                                base.CustomRemoteDatasourceRead(o);
                            },
                            update: function (o) {
                                base.CustomRemoteDatasourceUpdate(o);
                            },
                            destroy: function (o) {
                                base.CustomRemoteDatasourceDestroy(o);
                            },
                            parameterMap: function (data, operation) {
                                console.log("ds transport", operation, data);
                            }
                        },
                        schema: {
                            type: "json",
                            model: {
                                id: "Id",
                                fields: { Id: "Id" }
                            }
                        },
                        change: function (e) {
                            base.vueRoot.model = [];
                            for (var i = 0; i < e.items.length; i++)
                                base.vueRoot.model.push(KendoDataExtracter_1.KendoDataExtracter.GetPlainDataFromKendoDatasourceEntry(e.items[i]));
                        },
                        requestEnd: function (e) {
                            _this.DSReqestEndHandler(e);
                        },
                        error: function (e) {
                            _this.DSErrorHandler(e);
                        }
                    });
                    if (this.options.IsInEditMode)
                        this.remoteDataSource.fetch(function () {
                            console.log(base.remoteDataSource.hasChanges());
                        });
                    else
                        this.remoteDataSource.add(this.GetNewInstanceOfType(this.options.type));
                };
                return TvsScreensBoxesConnectControllerWithCustomCRUDDataSource;
            }(BasicViewControllerWithCRUDDataSource_1.BasicViewControllerWithCRUDDataSource));
            Controllers.TvsScreensBoxesConnectControllerWithCustomCRUDDataSource = TvsScreensBoxesConnectControllerWithCustomCRUDDataSource;
        })(Controllers = AV2.Controllers || (AV2.Controllers = {}));
    })(AV2 || (AV2 = {}));
    $(function () {
        var optionsList = window["TvsScreensBoxesConnectControllerData"];
        for (var i in optionsList) {
            window["TvsScreensBoxesConnectController" + i] = new AV2.Controllers.TvsScreensBoxesConnectControllerWithCustomCRUDDataSource(optionsList[i]);
        }
    });
});
//# sourceMappingURL=TvsScreensBoxesConnectController.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/Controllers/TvsScreensBoxesConnectController.js
// module id = 384
// module chunks = 0